import {Localizer} from '../../../libs/shared/core/src/helpers/internationalization/localizeTypes';
import {AnalyticsDonutMetricValue, AnalyticsTableMetric} from '../../models/api/analyticsMetricsModel';
import {TableToGraphTransformer} from './analyticsMetricsTransformers';
import {
  AnalyticsComputedGraphMetricBase,
  AnalyticsComputedGraphMetricsEnum,
} from './analyticsMetricsTransformersTypes';
import {histoMetricToDonut} from './histoMetricToDonut';

/*
 * Types.
 */

export interface StageRepliesToResolutionGraphMetric
  extends AnalyticsComputedGraphMetricBase<AnalyticsDonutMetricValue> {}

/*
 * Transformer.
 */

export const stageRepliesToResolutionHistoToGraph: TableToGraphTransformer = (
  metricData: AnalyticsTableMetric | undefined,
  localize: Localizer,
): StageRepliesToResolutionGraphMetric =>
  /**
   * Row is something like:
   * [
   *   {type: AnalyticsDataPointTypeEnum.TEXT, previousValue: "1", value: "2"},
   *   {type: AnalyticsDataPointTypeEnum.PERCENTAGE, previousValue: 0.4375, value: 0.3235294117647059}
   * ]
   */
  histoMetricToDonut(AnalyticsComputedGraphMetricsEnum.STAGE_AVG_RESOLUTION_TIME_GRAPH, metricData, localize);
